module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white",
    attrs: {
      "id": "countdown"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('div', {
    staticClass: "countdown bg-white border border-gray-light border-round sm-no-padding-rl no-padding-rl sm-padding-5 padding-2-5 position-relative"
  }, [_c('div', {
    staticClass: "no-padding-tb padding-3-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 sm-margin-4 sm-no-margin-bottom sm-no-margin-rl",
    attrs: {
      "data-mh": "mh-col-countdown"
    }
  }, [_c('div', {
    staticClass: "clock",
    attrs: {
      "data-until-date": "1516167000"
    }
  }, [_c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.days) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("dage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.hours) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("timer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.minutes) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("min.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.seconds) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("sek.")])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 countdown-text",
    attrs: {
      "data-mh": "mh-col-countdown"
    }
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle sm-text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 xs-text-extra-large title-medium text-uppercase"
  }, [_vm._v("Sæt kryds i kalenderen")]), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt margin-1 no-margin-bottom no-margin-rl text-large text-gray-dark"
  }, [_vm._v("Netværksmødet afholdes om:")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2ba9ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/countdown.vue
// module id = 235
// module chunks = 1